export const SNOOZE_DEFAULT_TIME = "09:00";

/** Demain à minuit local (date par défaut du picker). */
export function defaultSnoozeDate(now = new Date()): Date {
  const d = new Date(now);
  d.setDate(d.getDate() + 1);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function startOfDay(d: Date): Date {
  const next = new Date(d);
  next.setHours(0, 0, 0, 0);
  return next;
}

export function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function isBeforeDay(a: Date, b: Date): boolean {
  return startOfDay(a).getTime() < startOfDay(b).getTime();
}

/** Grille 6×7 (lun → dim) pour le mois affiché. */
export function buildCalendarGrid(viewMonth: Date): (Date | null)[][] {
  const year = viewMonth.getFullYear();
  const month = viewMonth.getMonth();
  const first = new Date(year, month, 1);
  const startOffset = (first.getDay() + 6) % 7;
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const cells: (Date | null)[] = [];
  for (let i = 0; i < startOffset; i += 1) cells.push(null);
  for (let day = 1; day <= daysInMonth; day += 1) {
    cells.push(new Date(year, month, day));
  }
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks: (Date | null)[][] = [];
  for (let i = 0; i < cells.length; i += 7) {
    weeks.push(cells.slice(i, i + 7));
  }
  return weeks;
}

/** Combine date locale + heure « HH:mm » → ISO. */
export function buildSnoozeUntilIso(date: Date, time: string): string | null {
  const match = /^(\d{1,2}):(\d{2})$/.exec(time.trim());
  if (!match) return null;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;

  const combined = new Date(date);
  combined.setHours(hours, minutes, 0, 0);
  if (combined.getTime() <= Date.now()) return null;

  return combined.toISOString();
}

export function formatSnoozeUntil(untilIso: string, now = new Date()): string {
  const until = new Date(untilIso);
  if (Number.isNaN(until.getTime())) return untilIso;

  const sameDay =
    until.getFullYear() === now.getFullYear() &&
    until.getMonth() === now.getMonth() &&
    until.getDate() === now.getDate();

  const time = until.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });

  if (sameDay) {
    return `Aujourd'hui ${time}`;
  }

  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const isTomorrow =
    until.getFullYear() === tomorrow.getFullYear() &&
    until.getMonth() === tomorrow.getMonth() &&
    until.getDate() === tomorrow.getDate();

  if (isTomorrow) {
    return `Demain ${time}`;
  }

  return until.toLocaleString("fr-FR", {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}
